import React from 'react';

function CampaignTemplateFilters({
    searchTerm,
    onSearchTermChange,
    onSearchSubmit,
    typeFilter,
    onTypeFilterChange,
    activeFilter,
    onActiveFilterChange,
    sortBy,
    onSortByChange,
    sortOrder,
    onSortOrderChange,
    onClear,
    canClear,
}) {
    return (
        <form onSubmit={onSearchSubmit} className="process-queue-filters mb-4 p-3 bg-light rounded border">
            <div className="row g-2 g-md-3 align-items-center process-queue-filters__row">
                <div className="col-12 col-md-6 col-lg-auto process-queue-filters__item process-queue-filters__item--search">
                    <div className="input-group input-group-sm">
                        <span className="input-group-text process-queue-filters__label">Search</span>
                        <input
                            type="text"
                            className="form-control process-queue-filters__control"
                            placeholder="Search by name…"
                            value={searchTerm}
                            onChange={(e) => onSearchTermChange(e.target.value)}
                        />
                        {searchTerm && (
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => onSearchTermChange('')}
                                aria-label="Clear search input"
                            >
                                <i className="bi bi-x"></i>
                            </button>
                        )}
                    </div>
                </div>

                <div className="col-6 col-md-3 col-lg-auto process-queue-filters__item">
                    <div className="input-group input-group-sm">
                        <span className="input-group-text process-queue-filters__label">Type</span>
                        <select
                            className="form-select form-select-sm process-queue-filters__control"
                            value={typeFilter}
                            onChange={(e) => onTypeFilterChange(e.target.value)}
                        >
                            <option value="">All types</option>
                            <option value="EMAIL">Email</option>
                            <option value="SMS">SMS</option>
                        </select>
                    </div>
                </div>

                <div className="col-6 col-md-3 col-lg-auto process-queue-filters__item">
                    <div className="input-group input-group-sm">
                        <span className="input-group-text process-queue-filters__label">Status</span>
                        <select
                            className="form-select form-select-sm process-queue-filters__control"
                            value={activeFilter}
                            onChange={(e) => onActiveFilterChange(e.target.value)}
                        >
                            <option value="">All</option>
                            <option value="true">Active</option>
                            <option value="false">Inactive</option>
                        </select>
                    </div>
                </div>

                <div className="col-6 col-md-3 col-lg-auto process-queue-filters__item">
                    <div className="input-group input-group-sm">
                        <span className="input-group-text process-queue-filters__label">Sort by</span>
                        <select
                            className="form-select form-select-sm process-queue-filters__control"
                            value={sortBy}
                            onChange={(e) => onSortByChange(e.target.value)}
                        >
                            <option value="createdAt">Created At</option>
                            <option value="name">Name</option>
                        </select>
                    </div>
                </div>

                <div className="col-6 col-md-3 col-lg-auto process-queue-filters__item">
                    <div className="input-group input-group-sm">
                        <span className="input-group-text process-queue-filters__label">Order</span>
                        <select
                            className="form-select form-select-sm process-queue-filters__control"
                            value={sortOrder}
                            onChange={(e) => onSortOrderChange(e.target.value)}
                        >
                            <option value="DESC">Newest first</option>
                            <option value="ASC">Oldest first</option>
                        </select>
                    </div>
                </div>

                <div className="col-12 col-lg-auto process-queue-filters__actions d-flex flex-nowrap gap-2">
                    <button type="submit" className="btn btn-primary btn-sm text-nowrap">
                        <i className="bi bi-search me-1"></i>
                        Search
                    </button>
                    <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm text-nowrap"
                        onClick={onClear}
                        disabled={!canClear}
                        title="Clear filters"
                    >
                        <i className="bi bi-x-lg me-1"></i>
                        Clear
                    </button>
                </div>
            </div>
        </form>
    );
}

export default CampaignTemplateFilters;
